export default __webpack_public_path__ + "static/media/baseline-signal_cellular_2_bar-24px.1d8011bc.svg";